import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { LabTech, useLabTechsContext } from '../../LabTechsContext'
import { useRemoveLabTechMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<LabTech> {
  const { refetch } = useLabTechsContext()
  const [remove] = useRemoveLabTechMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      removeLabTech: {
        labTech: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveLabTech,
    disabled: ({
      concreteCoreBreakDatas,
      concreteTestBreakDatas,
      testingLabs,
    }) =>
      !!testingLabs.length ||
      !!concreteTestBreakDatas.length ||
      !!concreteCoreBreakDatas.length
        ? {
            message:
              'Lab Techs cannot be removed if they are associated with any Testing Labs or Break Data',
          }
        : false,
    hard: true,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
